// Functional component
import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Input, InputGroup, InputGroupAddon, InputGroupText, Table } from 'reactstrap';
import { Card, CardHeader, CardBody, CardText, CardFooter } from 'reactstrap';
import { useParams } from 'react-router-dom';
import './PDF.css';
import AllPagesPDFViewer from './All-page';

const localBack = process.env.REACT_APP_BACK;

const Certificado = ({ cod }) => {
    const [loading1, setLoading1] = useState(true);
    const [loading2, setLoading2] = useState(true);
    const [buscar, setBuscar] = useState(cod);
    const [pdfResult, setPdfResult] = useState(0);
    const [pdfBase64, setPdfBase64] = useState('');
    const [sendRequest, setSendRequest] = useState(false);
    const { codigo } = useParams()
    /*console.log(codigo);*/

    useEffect(() => {
        if (sendRequest) {
            searchById(buscar);
            setSendRequest(false);
        }
    },
        [sendRequest]);

    useEffect(() => {
        /*console.log(`Codigo: ${buscar}`);*/
        searchById();
    }, [buscar]);

    const getPdf = useCallback((id) => {
        fetch(localBack + '/api/FileUpload/DescargarEvidencia/' + id, {
            method: 'GET',
        })
            .then(response => {                
                return response.json();
            })
            .then(data => {
                if (data !== '') {
                    setPdfBase64("data:application/pdf;base64," + data + "");
                    setPdfResult(1);
                } else {
                    setPdfResult(-1)
                }
            });
    });

    const searchById = useCallback(
        () => {
            /*this.populateActividad(this.state.buscar, 'A');*/
            if (buscar !== '') {
                fetch(localBack + '/api/Certificado/GetByCodigo/' + buscar, {
                    method: 'GET',
                    /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.strEstado === "S") {
                            let certificadoRow = data.objDatos;
                            let codigo = certificadoRow.rutapdf.split(',');
                            getPdf(codigo[1]);
                        } else {
                            //console.log('Documento No existe.');
                        }
                    });
                setPdfResult(1);
            } else {
                setPdfResult(-1);
            }
        });

    return (
        <div className="wrapper">

            <Row style={{ minHeight: '75vh' }}>
                <Col>
                    <Card>
                        <CardHeader>Autenticaci&oacute;n</CardHeader>
                        <CardBody>

                            <CardText>Ingrese el c&oacute;digo del certificado para verificar autenticidad.</CardText>
                            <CardText>
                                <Row>
                                    <InputGroup className="col-md-12">
                                        <Input placeholder="201505398083604052022" onChange={(e) => setBuscar(e.target.value)} value={buscar} />
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText className='icon-pointer' onClick={() => setSendRequest(true)}>
                                                Consultar
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Row>
                            </CardText>
                            {pdfResult > 0 ?
                                <Card body className="all-page-container" style={{ alignContent: 'center', height: '100%', maxHeight: '500px', overflow: 'auto' }}>
                                    <AllPagesPDFViewer pdf={pdfBase64} />
                                </Card>
                                : pdfResult < 0
                                    ?
                                    <Card body className="text-center py-3">
                                        <CardText>No se encontr&oacute; el certificado.</CardText>
                                        <CardText>Por favor, verifique que le c&oacute;digo se haya escrito correctamente.</CardText>
                                    </Card>
                                    :
                                    <></>
                            }
                        </CardBody>
                    </Card>
                </Col>
            </Row>

        </div>
    );
}
export default Certificado;